export const users = {
	title: "Users",
	comingSoon: "This feature will be a future enhancement",
};
